import classNames from 'classnames';
import classes from './index.module.scss';
import Typography from 'components/generics/texts/Typography';
import Head from 'components/next/Head';
import React, { HTMLAttributes } from 'react';
import Image from 'next/image';

const ResidentSignUpAnimation = ({
  className,
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={classNames(classes.container, className)}>
      <Head title="Sign Up" />
      <div className={classes.topContainer}>
        <Typography className={classes.title}>
          Set up your resident account to find your next home
        </Typography>
      </div>
      <div className={classes.imagesContainer}>
        <Image
          className={classNames(classes.image, classes.city)}
          src={'/assets/welcome/welcomeBg.png'}
          alt={'welcomeBg'}
          width={1000}
          height={1000}
        />
        <Image
          className={classNames(classes.image, classes.bushes)}
          src={'/assets/welcome/welcomeFg.png'}
          alt={'welcomeFg'}
          width={1000}
          height={1000}
        />
      </div>
    </div>
  );
};

export default ResidentSignUpAnimation;
